import useCurrentUser from 'hooks/useCurrentUser';
import useProfessionalQualifications from 'hooks/useProfessionalQualifications';
import { getMissingProfessionalOptions } from '@medely/credentials-tools';
import type { ICondition, IProfessionalQualification, IQualification } from '@medely/types';

export type QualificationToProfessionalQualification = Record<
  IQualification['id'],
  Pick<IProfessionalQualification, 'id' | 'status'>
>;

const useMissingConditionOptions = (condition: ICondition) => {
  const { currentUser, refetch: refetchUser } = useCurrentUser();
  const { allProfessionalQualifications, refetch: refetchPqs } = useProfessionalQualifications();

  const options = getMissingProfessionalOptions({
    condition,
    professionalQualifications: allProfessionalQualifications,
    satisfiedConditionIds: currentUser?.professional?.satisfied_condition_ids ?? [],
  });

  const refetchConditionOptions = async () => {
    // Without the inner refetch stale data comes back
    const refetchData = await Promise.all([
      (await refetchUser()).refetch(),
      (await refetchPqs()).refetch(),
    ]);
    const satisfied_condition_ids = refetchData[0].data?.professional?.satisfied_condition_ids;
    const professionalQualifications = refetchData[1].data;

    return getMissingProfessionalOptions({
      condition,
      professionalQualifications: professionalQualifications ?? [],
      satisfiedConditionIds: satisfied_condition_ids ?? [],
    });
  };

  return { options, refetchConditionOptions };
};

export default useMissingConditionOptions;
